import { render, staticRenderFns } from "./ChangeRequestStatus.vue?vue&type=template&id=1963751c"
import script from "./ChangeRequestStatus.vue?vue&type=script&lang=ts"
export * from "./ChangeRequestStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports